import * as React from 'react'
import { Link, Redirect } from 'react-router-dom'

const ManageFishScreen = (props) => {
  if( !props.fish.fishTypes ) return <Redirect to="/manageapp" />
  return (
    <div>
      <Link
          className="btn btn-primary btn-sm btn-block mb-3"
          to="manage-fish-detail"
        >Dodaj rybę
      </Link>

      <div className="list-group">
        {props.fish.fishTypes.map( (fish,key) => {
          return (
            <Link 
              key={key}
              className="list-group-item"
              to={{
                pathname: 'manage-fish-detail',
                fish
              }}
            >
              <div className="row">
                <div className="col-md-3">
                  {fish.img && <img alt="" className="img-fluid" src={ fish.img } />}
                </div>
                <div className="col-md-9">
                  <p className="m-0">{fish.name}</p>
                  <span className="small text-muted">{fish.description}</span>
                </div>
              </div>
            </Link>
          
        )}
      )}
      </div>
    </div>
  )
}

export default ManageFishScreen


// WEBPACK FOOTER //
// ./src/screens/ManageFish/ManageFishScreen.js